import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const header = (isStorefronts: boolean) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${isStorefronts ? "0 0 2rem 0" : "0 2rem 2rem 2rem"};
  margin-top: 3.5rem;

  margin: auto;
  max-width: 34rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-top: 1.5rem;
  }
`;
